// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"277":"ef1f117d","769":"15bedbd5"}[chunkId] + ".js";
};